const returnSchema = [
  {
    name: 'touchpos_out_of_stock_warning',
    initialValue: '',
    input: {
      className: 'touchpos_out_of_stock_warning',
      label: 'Display product out of stock warning',
      type: 'input',
      as: 'select',
      options: [
        { name: 'No', value: '' },
        { name: 'Give warning', value: 'warning' },
        { value: 'confirmation', name: 'Confirm before adding to receipt' },
      ],
    },
  },
  {
    name: 'touchpos_search_product_code_from_middle',
    initialValue: '',
    input: {
      className: 'touchpos_search_product_code_from_middle',
      label: 'Search product code from the middlesh',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_sort_products_by_code',
    initialValue: '',
    input: {
      className: 'touchpos_sort_products_by_code',
      label: 'Sort products by Code',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_product_row_auto_open',
    initialValue: '',
    input: {
      className: 'touchpos_disable_product_row_auto_open',
      label: 'Disable opening product view from product search',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_related_products_popup',
    initialValue: '',
    input: {
      className: 'touchpos_disable_related_products_popup',
      label: 'Disable opening related product view',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_zero_price_auto_open',
    initialValue: '',
    input: {
      className: 'touchpos_disable_zero_price_auto_open',
      label: 'Disable product edit view open for products with zero price',
      type: 'checkbox',
    },
  },

  {
    name: 'touchpos_exact_code_match_adds_product_to_ticket',
    initialValue: '',
    input: {
      className: 'touchpos_exact_code_match_adds_product_to_ticket',
      label: 'Exact code match adds product to ticket',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_product_image_display',
    initialValue: '',
    input: {
      className: 'touchpos_disable_product_image_display',
      label: 'Hide product images on the grid',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_autoclose_line_after_discount_selected',
    initialValue: '',
    input: {
      className: 'touchpos_autoclose_line_after_discount_selected',
      label: 'Auto close document row after discount selected',
      type: 'checkbox',
    },
  },
];

export default returnSchema;
